__turbopack_context__.v({
  "shadow": "AcfShadow-module-scss-module__3qj1Ha__shadow",
});
